/**
 * file : Directions.jsx
 * 설명 : 오시는 길 화면
 */

import { useEffect } from 'react';
const { kakao } = window;
  
export default function Directions() {

    useEffect(() => {
    const container = document.getElementById('map');
    const options = {
      center: new kakao.maps.LatLng(35.12, 129.1),
      level: 3
    };
    // 지도를 생성
    const map = new kakao.maps.Map(container, options);
    // 주소-좌표 변환 객체를 생성
    const geocoder = new kakao.maps.services.Geocoder();
    // 주소로 좌표를 검색
    geocoder.addressSearch('다산중앙로 19번길 25-23', function (result, status) {

      // 정상적으로 검색이 완료됐으면 
      if (status === kakao.maps.services.Status.OK) {
  
        var coords = new kakao.maps.LatLng(result[0].y, result[0].x);
  
        // 결과값으로 받은 위치를 마커로 표시
        var marker = new kakao.maps.Marker({
          map: map,
          position: coords
        });
  
        // 인포윈도우로 장소에 대한 설명을 표시
        var infowindow = new kakao.maps.InfoWindow({
          content: '<div style="width:150px;text-align:center;padding:6px 0;">HS 솔루션</div>'
        });
        infowindow.open(map, marker);
  
        // 지도의 중심을 결과값으로 받은 위치로 이동
        map.setCenter(coords);
      }
    })
  });
  return (
    <div>
        <main className="main" id="contents">
            <div className="container text-center">
                <h1 className="common-title--h1 text-gray-2">오시는 길</h1>
            </div>
            <div className="container">
                <p className="common-text--24 text-gray-3 text-center mb-5 wow fadeInUp">다산중앙로 19번길 25-23 (다산진건 블루웨일 지식산업센터 2차) 445호</p>
                  <div id='map' style={{ height: '600px' }}></div>
            </div>
        </main>
    </div>
  )
}